import React, { useMemo, useState } from "react";
import OAuthCardLayout from "./OAuthCardLayout";
import { Button, FormGroup, Row } from "reactstrap";
import { Link, Redirect } from "react-router-dom/cjs/react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import apiURL from "../../../services/apiURL";
import { useLocation } from "react-router";



const API_URL = apiURL("authentication")
const AuthAppResultLayout = () => {
    const [commandType, setCommandType] = useState("");
    const [appUniId,setAppUniId] =useState("")
    const [oldFlag,setOldFlag] =useState("")
    const [isDisabled, setIsDisabled] = useState(false);
    const [disableUi, setDisableUi] = useState(false)
    var location = useLocation();
    var app_id = location.state?.app_id;
    var po_user_name = location.state?.po_user_name;
    var master_customer_id = location.state?.master_customer_id;
    var return_path = location.state?.return_path;
    var partnerEmail = location.state?.client_email;
    var appName = location.state?.app_name;
    var state =location.state?.state;
    if (!appName && !app_id && !po_user_name && !return_path && !master_customer_id && !partnerEmail) {
        return (
            <Redirect to={`${process.env.PUBLIC_URL}/*/`} />
        );
    }
    const fetchPracticeAccessCheck = (data) => {        
        var body =
        {
            "app_id": app_id,
            "po_user_name": po_user_name,
            "master_customer_id": master_customer_id,
        }
        axios
            .post(`${API_URL}oauth_practice_access_check`, body)
            .then((res) => {
                setIsDisabled(false)
                if (res.status != 204) {
                    setAppUniId(res.data.items.api_unique_id)
                    setOldFlag(res.data.items.opt_flag)
                    setCommandType("update")
                }
                else {
                    setCommandType("insert")
                }
            })
            .catch((error) => {
                setIsDisabled(false)

                const resMessage =
                    (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
                toast.error(resMessage);
                // toast.warning(error.response.data.long_message + " " + error.response.data.more_information);
            });
    };
    const fetchCheckSpuInstallationStatus = () => {
        setIsDisabled(true)
        var body =
        {
            "master_customer_id": master_customer_id,
        }
        axios
            .post(`${API_URL}oauth_check_spu_installation_status`, body)
            .then((res) => {
                if (res.data.items.is_spu_installed == true) {
                    fetchPracticeAccessCheck()
                }
                else {
                    setDisableUi(true) 
                    toast.error("Spu is not installed!!");
                }
            })
            .catch((error) => {
                const resMessage =
                    (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
                toast.error(resMessage);
                // toast.warning(error.response.data.long_message + " " + error.response.data.more_information);
            });
    };
    const UpdateUsersAuthPracticeDetail = (flag) => {
        setIsDisabled(true)

        if (commandType === "insert") {
            var body = {
                "user_name": po_user_name,
                "master_customer_id": master_customer_id,
                "app_id": app_id,
                "command_type": commandType,
                "old_flag":"0",
                "opt_flag": flag,
                "is_add_updated_by_admin": "false",
                "app_name": appName,
                "add_updated_by": partnerEmail,
                "request_from":"oAuthPage"
            }
        }
        else {
            var body = {
                "user_name": po_user_name,
                "master_customer_id": master_customer_id,
                "app_id": app_id,
                "command_type": commandType,
                "old_flag":oldFlag,
                "opt_flag": flag,//work on this if user click on deny optflag should be "0"
                "is_add_updated_by_admin": "false",
                "app_name": appName,
                "uid":appUniId,
                "add_updated_by": partnerEmail,
                "request_from":"oAuthPage"

            }
        }
        axios
            .post(`${API_URL}oauth_add_edit_practice_access`, body)
            .then((res) => {
                const queryString =`?state=${state}&code=${appUniId}`;
                window.location.href = `${return_path}${queryString}`;
                setIsDisabled(false)
            })
            .catch((error) => {
                setIsDisabled(false)
                const resMessage =
                    (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
                toast.error(resMessage);
                // toast.warning(error.response.data.long_message + " " + error.response.data.more_information);
            });
    };
    useMemo(() => {
        fetchCheckSpuInstallationStatus()
    }, [])
    return (
        <div>
            <OAuthCardLayout
                // url={oauthMeta?.url}
                // name={oauthMeta?.name}
                lg={4}>
                <Row className="flex-start w-100 max-width-705" style={{ opacity: disableUi ? 0.5 : 1 }}>
                    <p className="fs--1 font-weight-bold text-black">This Application would like to connect to your sikka account.</p>
                    <p className="fs--1">This application will have access to your practice's all location(s)</p>
                    <p className="fs--1">To change the practice location access, please log into <a href="https://api.sikkasoft.com/v4/portal/authentication/login" target={"_self"}>Sikka api portal</a> and make changes.</p>
                    <p className="fs--1">{appName} will be charged for the registered location(s), regardless of their activation status.</p>
                    <p className="fs--1">For more details : <Link to={{ pathname: "https://www.sikka.ai/V3/Sikka_Billing_Terms.pdf" }} target="_blank">Sikka Billing terms</Link>, <Link to={{ pathname: "https://www.sikka.ai/api-license-agreement" }} target="_blank">Sikka API license agreement</Link></p>
                    {/* <p className="fs--1">Please make sure Sikka platform utility(SPU) has been installed and refreshing for this practice</p> */}
                    <p className="fs--1">By proceeding, you agree to Sikka Software Corporation's Legal <Link to={{ pathname: "https://www.sikkasoft.com/terms-of-service" }} target="_blank">Terms of Service</Link> and <Link to={{ pathname: "https://www.sikkasoft.com/privacy-policy" }} target="_blank">Privacy Policy</Link></p>

                    <Row className='d-flex flex-wrap col-11 mx-auto justify-content-evenly pl-pr-10'>
                        <FormGroup className="ml-mr-2">
                            {/* <a href={oauthMeta?.redirectUri} target="_self"> */}
                            <Button
                                color='primary'
                                name='Deny'
                                className="pl-pr-2 fs--1 btn-secondary"
                                disabled={isDisabled}
                                onClick={() => {
                                    if (commandType != "insert") {
                                        UpdateUsersAuthPracticeDetail("0")
                                    }
                                    else {
                                        window.location.href = return_path;
                                    }
                                }}>
                                Deny
                            </Button>
                            {/* </a> */}
                        </FormGroup>
                        <FormGroup>
                            <Button
                                color='primary'
                                type='submit'
                                name='Submit'
                                className="pl-pr-2 fs--1 btn-primary"
                                disabled={isDisabled}
                                onClick={() => {
                                    UpdateUsersAuthPracticeDetail("1")
                                }}>
                                Allow
                            </Button>
                        </FormGroup>
                    </Row>
                </Row>
            </OAuthCardLayout>
        </div>
    )
}

export default AuthAppResultLayout;